import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {EnumValidValueItemModel} from '../../../../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../../../../services/static-data.service';

@Component({
  selector: 'app-diagnosis-ecir-dialog',
  templateUrl: './diagnosis-ecir-dialog.component.html',
  styleUrls: ['./diagnosis-ecir-dialog.component.scss']
})
export class DiagnosisEcirDialogComponent implements OnInit {
  selectedEcirValidValueItem: string;
  ecirEnums: EnumValidValueItemModel[] = [];
  constructor(private dialogRef: MatDialogRef<DiagnosisEcirDialogComponent>,
              private staticDataService: StaticDataService) { }

  ngOnInit(): void {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.ecirEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDiagECIR');
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.selectedEcirValidValueItem);
  }

  onDiagramClick(id: string) {
    this.selectedEcirValidValueItem = id.toLowerCase();
  }
}
